module.exports = __webpack_public_path__ + "static/media/lamina12text.937aeeca.png";